import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { Select } from '../common/Select';
import { toast } from 'react-toastify';
import { api } from '../../utils/api';

const SHOP_TYPE_OPTIONS = [
  { value: 'ebay', label: 'eBay' },
  { value: 'aliexpress', label: 'AliExpress' },
];

interface AddShopModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export function AddShopModal({ isOpen, onClose, onSuccess }: AddShopModalProps) {
  const [shopType, setShopType] = useState('');
  const [connecting, setConnecting] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const resetForm = () => {
    setShopType('');
    setErrors({});
  };

  const handleClose = () => {
    if (connecting) {
      return;
    }
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    const nextErrors: Record<string, string> = {};

    if (!shopType) {
      nextErrors.shopType = 'Shop type is required';
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    const connectUrlPath = shopType === 'ebay'
      ? '/ebay/get-connect-url?lang=DE'
      : '/aliexpress/get-connect-url';

    setConnecting(true);

    try {
      const response = await api.get(connectUrlPath);
      const responseData = await response.json();

      if (!responseData.connectUrl) {
        throw new Error('No connect URL returned');
      }

      onSuccess();
      window.location.href = responseData.connectUrl;
    } catch (error: any) {
      toast.error(error.message || `Failed to start ${shopType} connection`);
      setConnecting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      title="Add Shop"
      onClose={handleClose}
      width="medium"
      actions={[
        {
          label: 'Cancel',
          preset: 'white',
          onClick: handleClose,
          disabled: connecting,
        },
        {
          label: connecting ? 'Connecting...' : 'Connect',
          preset: 'primary',
          onClick: handleSubmit,
          disabled: connecting,
        },
      ]}
    >
      <div className="space-y-4">
        <Select
          label="Shop type"
          value={shopType}
          onChange={setShopType}
          options={SHOP_TYPE_OPTIONS}
          placeholder="Select a shop type"
          required
          error={errors.shopType}
        />
      </div>
    </Modal>
  );
}
